import { OverlayModule } from '@angular/cdk/overlay';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule, forwardRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';

import { MatNativeDateModule } from '@angular/material/core';
import { FormlibModule } from '@sondermind/formlib';
import { UploadDataService, FILE_UPLOAD_SERVICE } from '@sondermind/data-access/formlib';

import { IrisTextInputModule } from '@sondermind/iris/text-input';
import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisCheckboxModule } from '@sondermind/iris/checkbox';
import { IrisDropdownModule } from '@sondermind/iris/dropdown';
import { IrisFormFieldModule } from '@sondermind/iris/form-field';
import { IrisIconButtonModule } from '@sondermind/iris/icon-button';
import { IrisIconComponent } from '@sondermind/iris/icon';

import { SondermindCommonModule } from '@sondermind/features/modules/common';
import { InsuranceForm } from '@sondermind/data-access/client-insurance';
import { CardIconPipe, CreditCardDisplayPipe, PipesModule } from '@sondermind/utilities/pipes';
import { SelfPayCostEstimateDetailedComponent } from '@sondermind/features/client-facing/cost-estimation';
import { GoogleMapsAutoCompleteDirective } from '@sondermind/google-maps';
import { DesignModule } from '@sondermind/core/design.module';
import { CoreModule } from '@sondermind/core/core.module';

import { RedemptionCodeForm } from './models/redemption-form';
import { ClientContactFormComponent } from './components/client-contact-form/client-contact-form.component';
import { CloseAddEditComponent } from './components/close-add-edit/close-add-edit.component';
import { CreditCardAddComponent } from './components/credit-card-add/credit-card-add.component';
import { CreditCardEditComponent } from './components/credit-card-edit/credit-card-edit.component';
import { EapAddComponent } from './components/eap-add/eap-add.component';
import { InsuranceAddComponent } from './components/insurance-add/insurance-add.component';
import { InsuranceReviewComponent } from './components/insurance-review/insurance-review.component';
import { ProfileEditFormComponent } from './components/profile-edit-form/profile-edit-form.component';
// eslint-disable-next-line max-len
import { InsuranceVerificationFailedComponent } from './components/insurance-verification-failed/insurance-verification-failed.component';
import { BvErrorComponent } from './components/bv-error/bv-error.component';
import { DemographicUpdateComponent } from './components/demographic-update/demographic-update.component';
// eslint-disable-next-line max-len
import { CoverageNotificationBannerComponent } from './components/coverage-notification-banner/coverage-notification-banner.component';
import { BvErrorUIStore } from './stores/bv-error-ui.store';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SelfPayCostEstimateDetailedComponent,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    CoreModule,
    FormlibModule,
    DesignModule,
    // ClientCommonModule,
    CdkStepperModule,

    IrisButtonModule,
    IrisCheckboxModule,
    IrisTextInputModule,
    IrisFormFieldModule,
    IrisDropdownModule,
    IrisIconButtonModule,
    PipesModule,
    CardIconPipe, // used in CreditCardEdit
    CreditCardDisplayPipe, // used in CreditCardEdit
    MatDatepickerModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatNativeDateModule,
    MatStepperModule,
    OverlayModule,
    SondermindCommonModule,
    IrisIconButtonModule,
    IrisIconComponent,
    CreditCardAddComponent,
    GoogleMapsAutoCompleteDirective
  ],
  declarations: [
    ProfileEditFormComponent,
    InsuranceAddComponent,
    InsuranceReviewComponent,
    InsuranceVerificationFailedComponent,
    EapAddComponent,
    CreditCardEditComponent,
    CloseAddEditComponent,
    ClientContactFormComponent,
    BvErrorComponent,
    DemographicUpdateComponent,
    CoverageNotificationBannerComponent
  ],
  exports: [
    ProfileEditFormComponent,
    InsuranceAddComponent,
    InsuranceReviewComponent,
    InsuranceVerificationFailedComponent,
    CreditCardEditComponent,
    EapAddComponent,
    CloseAddEditComponent,
    ClientContactFormComponent,
    BvErrorComponent,
    DemographicUpdateComponent,
    CoverageNotificationBannerComponent,
    CreditCardAddComponent
  ],
  providers: [
    { provide: FILE_UPLOAD_SERVICE, useExisting: forwardRef(() => UploadDataService) },
    InsuranceForm,
    RedemptionCodeForm,
    BvErrorUIStore,
    provideNgxMask()
  ]
})
export class AccountEditModule {}
